/**
 * Phase 55 Plan 55-04 (Wave 2) — shared Recipe pill badge.
 *
 * Single component reused across every display surface named in
 * 55-CONTEXT.md ("Recipe pill replaces 0 in stock everywhere, no
 * exceptions"): ItemPicker, ItemCombobox, Add Item table, Cart Lines,
 * Order Detail, Stock-Out Fast Entry, edit-mode item dialog.
 *
 * Colour: muted rust brand accent (#B8523A) per 55-CONTEXT.md §Specifics,
 * WCAG AA on cream tint. Kept intentionally small (text-[10px]) to sit
 * alongside the existing badge stack in items-tab's name-cell row without
 * dominating it.
 */
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export function RecipePill({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "border-[#B8523A]/40 bg-[#B8523A]/10 text-[#B8523A] text-[10px] font-medium",
        className,
      )}
    >
      Recipe
    </Badge>
  );
}
